"use client";

export type TemaUsuario = "claro" | "escuro";

const TEMA_KEY_LEGADO = "bp-tema-aparencia";

export function normalizarPapelTema(papel?: string | null) {
  if (papel === "USUARIO" || papel === "GESTOR" || papel === "PLATFORM_ADMIN") {
    return papel;
  }
  return null;
}

export function chaveTemaPorPapel(papel?: string | null) {
  const normalizado = normalizarPapelTema(papel);
  return normalizado ? `${TEMA_KEY_LEGADO}:${normalizado}` : TEMA_KEY_LEGADO;
}

export function lerTemaSalvo(papel?: string | null): TemaUsuario {
  if (typeof window === "undefined") return "claro";
  try {
    const temaPorPapel = window.localStorage.getItem(chaveTemaPorPapel(papel));
    if (temaPorPapel === "escuro" || temaPorPapel === "claro") return temaPorPapel;
    return window.localStorage.getItem(TEMA_KEY_LEGADO) === "escuro" ? "escuro" : "claro";
  } catch {
    return "claro";
  }
}

export function salvarTemaUsuario(papel: string, tema: TemaUsuario) {
  const normalizado = normalizarPapelTema(papel);
  if (!normalizado) return;
  try {
    window.localStorage.setItem(chaveTemaPorPapel(normalizado), tema);
  } catch {}
  window.dispatchEvent(new CustomEvent("bp-theme-change", { detail: { papel: normalizado } }));
}
